export default __webpack_public_path__ + "static/media/quickbooks-brand-preferred-logo.097ede0e.png";